import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/core/services/common/common.service';
import { WorkspaceService } from '../../../../../core/services/workspace/workspace.service';


@Component({
  selector: 'app-select-workspace',
  templateUrl: './select-workspace.component.html',
  styleUrls: ['./select-workspace.component.scss'],
})
export class SelectWorkspaceComponent implements OnInit {
  userWorkSpaces: any = [];
  user: any = {};
  selectedWorkspace: any = {};
  error: boolean = false;
  disabled: boolean = false;
  isShowBlur: boolean = false;
  isShowInprocessing: boolean = false;
  constructor(
    private _router: Router,
    public _commonService: CommonService,
    private _workspaceService: WorkspaceService
  ) {}

  ngOnInit(): void {
    let data = localStorage.getItem('currentUser');
    if (data) {
      this.user = JSON.parse(data);
    }

    this.isShowInprocessing = true;
    // this._commonService.isLoading = true;
    this._workspaceService.getUserWorkspaces().subscribe((res) => {
      let { owned_workspaces, shared_workspaces, lastVisited_workspace } = res;
      localStorage.setItem(
        'owned_workspaces',
        JSON.stringify(owned_workspaces)
      );
      if (shared_workspaces == undefined) {
        localStorage.setItem('shared_workspaces', '[{}]');
      } else {
        localStorage.setItem(
          'shared_workspaces',
          JSON.stringify(shared_workspaces)
        );
      }

      let spaces = res;
      this.userWorkSpaces = spaces;
      if (
        this.userWorkSpaces.owned_workspaces.length > 5 ||
        this.userWorkSpaces.shared_workspaces > 5
      ) {
        this.isShowBlur = true;
      }
      if (lastVisited_workspace.ws_kuid !== '') {
        let last = {};
        owned_workspaces.forEach((ele: any) => {
          if (ele.ws_kuid === lastVisited_workspace.ws_kuid) {
            last = ele;
          }
        });
        shared_workspaces.forEach((ele: any) => {
          if (ele.ws_kuid === lastVisited_workspace.ws_kuid) {
            last = ele;
          }
        });

        if (owned_workspaces.length === 1) {
          localStorage.setItem(
            'lastVisited_workspace',
            JSON.stringify(owned_workspaces[0])
          );
          this._router.navigate(['/']);
        } else if (
          owned_workspaces.length === 0 &&
          shared_workspaces.length === 1
        ) {
          localStorage.setItem(
            'lastVisited_workspace',
            JSON.stringify(shared_workspaces[0])
          );
          this._router.navigate(['/']);
        }
        if (Object.keys(last).length !== 0) {
          localStorage.setItem('lastVisited_workspace', JSON.stringify(last));
          this._router.navigate(['/']);
        }
      }
      if (
        !(spaces.owned_workspaces.length > 0) &&
        !(spaces.shared_workspaces.length > 0)
      ) {
        this._router.navigate(['workspace/create-workspace']);
      }
      this.isShowInprocessing = false;
    });
  }

  onContinue(): void {
    if (Object.keys(this.selectedWorkspace).length === 0) {
      this._commonService.showWarning(
        'Select atleast one workspace',
        'Required'
      );
    } else {
      localStorage.setItem(
        'lastVisited_workspace',
        JSON.stringify(this.selectedWorkspace)
      );
      this._router.navigate(['/']);
    }
  }

  selectWorkspace(workspace: any): void {
    this.disabled = true;
    this.selectedWorkspace = workspace;
  }
  getInitials(name: string): string {
    if (!name) {
      return '';
    }
    const words = name.trim().split(/\s+/);
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    } else if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    } else {
      return '';
    }
  }
}
